import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Solucoes from "./pages/Solucoes";
import QuemSomos from "./pages/QuemSomos";
import Contato from "./pages/Contato";
import Legal from "./pages/Legal";
import { initLenis, lenisScrollTo } from "./lib/scroll";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-azul-50 p-8 text-center">
                    <div>
                        <p className="font-display text-2xl font-bold text-azul-900">Algo saiu do trilho.</p>
                        <p className="mt-2 text-tinta-suave">Recarregue a página para continuar.</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => lenisScrollTo(hash), 350);
            return () => clearTimeout(t);
        }
        lenisScrollTo(null);
    }, [pathname, hash]);
    return null;
}

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <div className="flex min-h-screen flex-col bg-white">
                    <Navbar />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/solucoes" element={<Solucoes />} />
                            <Route path="/quem-somos" element={<QuemSomos />} />
                            <Route path="/contato" element={<Contato />} />
                            <Route path="/politica-de-privacidade" element={<Legal doc="privacidade" />} />
                            <Route path="/termos-de-uso" element={<Legal doc="termos" />} />
                            <Route path="*" element={<Home />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
